export const EMPLOYEE_PROFILE_PATH = "/company/employees/:id";
